module.exports = {
  packageName: '@doctoroncallcom/redux',
}
